import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  authErrorSelector,
  authenticationSelector,
  authStatusSelector,
  authenticatedUserSelector,
  requestAuthCheck
} from '../slices/authSlice';

export const useAuth = () => {
  const dispatch = useDispatch();
  const status = useSelector(authStatusSelector);
  const user = useSelector(authenticatedUserSelector);
  const error = useSelector(authErrorSelector);
  const isAuthenticated = useSelector(authenticationSelector);
  const retry = useCallback(() => dispatch(requestAuthCheck()), [dispatch]);

  return { status, user, error, isAuthenticated, retry };
};
